<template>
    <div class="box show-import-placeholder">
        <svg-vue icon="hosting-benefit" class="placeholder-image" />

        <div class="placeholder-content">
            <div class="placeholder-title">
                {{ title }}
            </div>

            <div class="placeholder-text" v-html="content" /> <!-- eslint-disable-line vue/no-v-html -->
        </div>
    </div>
</template>
<script>
// Internal dependencies.
import { ImportStatus } from '@/utils/show';

export default {
    props: {
        importStatus: {
            required: true,
            type: Number,
        },
    },

    data: () => ({
        supportUrl: 'mailto:help@fusebox.fm',
    }),

    computed: {
        /**
         * Gets the component title.
         *
         * @returns {string} Component title.
         */
        title() {
            return this.importStatus === ImportStatus.Error
                ? 'Oops! Looks like we hit a snag.'
                : 'Hang tight!';
        },

        /**
         * Gets the component content.
         *
         * @returns {string} Component content.
         */
        content() {
            const content = this.importStatus === ImportStatus.Error
                ? 'We’re having trouble getting the information we need from your previous host. Contact our support team to get back on track — <a href="{supportUrl}">Contact Us</a>.'
                : 'We’re in the process of copying your podcast from your previous host. Check back in a little bit to begin uploading new episodes.';

            return content.replace('{supportUrl}', this.supportUrl);
        },
    },
};
</script>
